import React from "react";
import { Link, useParams } from "react-router-dom";
import { getTranslationById } from "slices/translationSlice";
import { useDispatch } from "react-redux";
import { usePermissions } from "layouts/Admin";
import moment from "moment";
import { SubmitButton } from "components/common/buttons/SubmitButton";
import LogsTable from "views/appointment/view/LogsTable";
import TranslationViewTable from "./TranslationViewTable";
import { getTransLogs } from "slices/translationSlice";
import TransLogsTable from "./TransLogsTable";
import FullPageLoader from "components/common/FullPageLoader";
import QuotationsTable from "./QuotationsTable";
import { approveQuote } from "slices/translationSlice";
import { rejectQuote } from "slices/translationSlice";
import Swal from "sweetalert2";
import { ViewQuotationModal } from "./ViewQuotationModal";
import SelectTranslatorModal from "components/common/SelectTranslatorModal";
import { assignTranslators } from "slices/inviteTranslatorSlice";
import toast from "react-hot-toast";
import { translationApproveSubmission } from "slices/inviteTranslatorSlice";
import { translationMarkInvoiceAsPaid } from "slices/inviteTranslatorSlice";
import { translationCancel } from "slices/inviteTranslatorSlice";
import CancelModal from "components/appointment/CancelModal";
import UploadDocument from "components/appointment/UploadDocument";
import { translationUploadDocument } from "slices/inviteTranslatorSlice";
import TranslatedDocumentsTable from "./TranslatedDocumentsTable";
import InvoiceTable from "./InvoiceTable";
import CotationPopup from "./CotationPopup";

const TranslationView = () => {
  const { id } = useParams();
  const { checkPermission } = usePermissions();
  const dispatch = useDispatch();
  const [item, setItem] = React.useState({});
  const [loading, setLoading] = React.useState(false);
  const [logs, setLogs] = React.useState([]);
  const [assignTranslator, setAssignTranslator] = React.useState(false);
  const [uploadDocumentTranslator, setUploadDocumentTranslator] =
    React.useState(false);

  const [invoiceSentTranslator, setInvoiceSentTranslator] =
    React.useState(false);

  const [cancelTranslator, setCancelTranslator] = React.useState(false);
  const [quotationView, setQuotationView] = React.useState({
    show: false,
    id: null,
  });

  const callViewApi = async () => {
    const callBack = (success, data) => {
      setLoading(false);
      if (success) {
        setItem(data);
      } else {
        setItem({});
      }
    };
    dispatch(getTranslationById(id, callBack));
  };


  //   fetch logs
  const fetchLogs = async () => {
    const callBack = (success, message, data) => {
      if (success) {
        setLogs(data);
      } else {
        console.log("res", message);
      }
    };
    dispatch(getTransLogs(id, callBack));
  };

  React.useEffect(() => {
    if (id) {
      setLoading(true);
      callViewApi();
      fetchLogs();
    }
  }, [id]);

  const mileageCheck = (val) => {
    return item?.appointment_details?.[val];
  };

  const rawDatetime = item?.created_at;

  const onApprove = () => {
    Swal.fire({
      title: "Confirmation",
      text: "Are you sure, you want to approve it?",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      showCancelButton: true,
    }).then(({ isConfirmed }) => {
      if (isConfirmed) {
        setLoading(true);
        const callBack = (success) => {
          if (success) {
            toast.success("Approved Successfully ", {
              className: "successToast",
            });
            const listCallBack = (success, data) => {
              setLoading(false);
              if (success) {
                setItem(data);
              } else {
                setItem({});
              }
            };
            dispatch(getTranslationById(item?.id, listCallBack));

            setLoading(false);
          } else {
          }
        };
        dispatch(approveQuote(item?.id, callBack));
      }
    });
  };

  const onReject = () => {
    Swal.fire({
      title: "Reason For Rejection",
      // text: "Are you sure, you want to reject it?",
      confirmButtonText: "Submit",
      cancelButtonText: "Cancel",
      showCancelButton: true,
      input: "text",
      inputPlaceholder: "Write here Reason for Rejection",
      inputValidator: (value) => {
        if (!value) {
          return "You need to write something!";
        }
      },
    }).then(({ isConfirmed, value }) => {
      if (isConfirmed) {
        const callBack = (success) => {
          if (success) {
            toast.success("Rejected Successfully ", {
              className: "successToast",
            });
            const listCallBack = (success, data) => {
              setLoading(false);
              if (success) {
                setItem(data);
              } else {
                setItem({});
              }
            };
            dispatch(getTranslationById(item?.id, listCallBack));

            setLoading(false);
          }
        };
        const data = {
          rejection_reason: value,
        };
        setLoading(true);
        dispatch(rejectQuote(item?.id, data, callBack));
      }
    });
  };

  const formattedDate = moment(rawDatetime, "YYYY-MM-DD HH:mm:ss").format(
    "MMM D, YYYY HH:mm:ss"
  );

  const [cotationPopup, setCotationPopup] = React.useState({
    open: false,
    documents: [],
  });

  const openQuotationView = (qId) =>
    setQuotationView({
      show: true,
      id: qId,
    });

  const handleAssignTranslator = () => {
    setAssignTranslator(true);
  };
  const handleCloseAssignTranslator = () => {
    setAssignTranslator(false);
  };
  const handleUploadDocumentTranslator = () => {
    setUploadDocumentTranslator(true);
  };
  const handleCloseUploadDocumentTranslator = () => {
    setUploadDocumentTranslator(false);
  };

  const handleCancelTranslator = () => {
    setCancelTranslator(true);
  };
  const handleCloseCancelTranslator = () => {
    setCancelTranslator(false);
  };

  const onAssign = (iterp_id) => {
    const isReassign = !!item?.interpreter_id;
    const payload = {
      interpreter_id: iterp_id,
    };
    const callBack = (success) => {
      if (success) {
        toast.success(isReassign ? "Reassigned Successfully" : "Assigned Successfully", {
          className: "successToast",
        });
        callViewApi();
        handleCloseAssignTranslator();
      } else {
        toast.error("Action failed. Please try again.", { className: "errorToast" });
      }
    };
    dispatch(assignTranslators(payload, id, callBack));
  };

  const onApproveSubmmision = () => {
    Swal.fire({
      title: "Confirmation",
      text: "Are you sure, you want to approve submission?",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      showCancelButton: true,
    }).then(({ isConfirmed }) => {
      if (isConfirmed) {
        setLoading(true);
        const callBack = (success) => {
          if (success) {
            toast.success("Approved Submission Successfully ", {
              className: "successToast",
            });
            callViewApi();

            setLoading(false);
          } else {
            setLoading(false);
          }
        };
        dispatch(translationApproveSubmission(id, callBack));
      }
    });
  };

  const onMarkInvoiceAsPaid = () => {
    Swal.fire({
      title: "Confirmation",
      text: "Are you sure, you want to Mark invoice as paid?",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      showCancelButton: true,
    }).then(({ isConfirmed }) => {
      if (isConfirmed) {
        setLoading(true);
        const callBack = (success) => {
          if (success) {
            toast.success("Successfully Marked invoice as paid ", {
              className: "successToast",
            });
            callViewApi();
            setLoading(false);
          } else {
            setLoading(false);
          }
        };
        dispatch(translationMarkInvoiceAsPaid(id, callBack));
      }
    });
  };

  
  const onCancelTranslation = (data) => {
    const callBack = (success) => {
      if (success) {
        toast.success("Cancelled Successfully", {
          className: "successToast",
        });

        callViewApi();
        handleCloseCancelTranslator();
      } else {
      }
    };
    dispatch(translationCancel(data, id, callBack));
  };
  // const onUploadDocument = (data) => {
  //   const callBack = (success) => {
  //     if (success) {
  //       toast.success("Uploaded Successfully", {
  //         className: "successToast",
  //       });
  //       callViewApi();
  //       handleCloseUploadDocumentTranslator();
  //     } else {
  //     }
  //   };
  //   const formdata = new FormData();
  //   formdata.append("file", data);
  //   dispatch(translationUploadDocument(formdata, id, callBack));
  // };
  const onUploadDocument = (data) => {
    setLoading(true);
    const callBack = (success) => {
      setLoading(false);
      if (success) {
        toast.success("Uploaded Successfully", {
          className: "successToast",
        });
        callViewApi();
        handleCloseUploadDocumentTranslator();
      } else {
        toast.error("Upload Failed");
      }
    };

    const formdata = new FormData();
    formdata.append("file", data);
    dispatch(translationUploadDocument(formdata, id, callBack));
  };

  console.log('statussssss',item?.status)

  return (
    <div className="content" style={{}}>
      {quotationView.show && (
        <ViewQuotationModal
          itemId={quotationView?.id}
          item={item}
          show={quotationView.show}
          onClose={() => setQuotationView({ show: false, id: null })}
        />
      )}

      <SelectTranslatorModal
        isOpen={assignTranslator}
        onClose={handleCloseAssignTranslator}
        onConfirm={onAssign}
        appointmentId={id}
        item={item}
        loader={loading}
        modalTitle={item?.interpreter_id ? "Reassign Translator" : "Assign Translator"}
      />

      <CancelModal
        isOpen={cancelTranslator}
        onClose={handleCloseCancelTranslator}
        onConfirm={onCancelTranslation}
        appointmentId={id}
        item={item}
        loader={loading}
        heading="Translation"
        showAppId={false}
      />

      <UploadDocument
        isOpen={uploadDocumentTranslator}
        onClose={handleCloseUploadDocumentTranslator}
        onConfirm={onUploadDocument}
        appointmentId={id}
        item={item}
        loader={loading}
      />

      <CotationPopup
        callViewApi={callViewApi}
        open={cotationPopup.open}
        onClose={() => setCotationPopup({ open: false, documents: [] })}
        documents={cotationPopup.documents}
        transId={id}
      />

      {loading && <FullPageLoader />}
      <div className="row_main_head bg-primary-secondaryCard">
        <h2 className={`main_heading main_heading1 mb-3`}>
          Translation job #{item?.transid}
        </h2>
        {/* <h2 className={`main_heading main_heading1 mb-3`}>
          Client : #{item?.accounts?.user?.name || "N/A"}
        </h2> */}
      </div>
      <div className="row_main_head bg-light-secondaryCard mt-3">
        <h2 className={`main_heading2 d-flex align-items-center gap-1 flex-wrap`} toLowerCase={"text-lowercase"}>
          Date & Time <span className="dateTime">{formattedDate}</span>
        </h2>

        <div className="row_check">
          <div className="text-transform-capitalize main_heading2">
            <span className="appLanguage">{item?.status}</span>
          </div>
        </div>
      </div>
      <div className="card_table view_table_custom">
        <div className="row-primary flex-wrap justify-content-between">
          <div className="row-primary flex-wrap">
            {(item?.status === "New Request" || item?.status === "Translator Declined") && (
              <SubmitButton
                buttonType="button"
                className={"green"}
                btnText="Assign"
                style={{ fontSize: "14px" }}
                handleSubmit={handleAssignTranslator}
              />
            )}
            {item?.interpreter_id &&
              item?.status !== "Cancelled" &&
              item?.status !== "Client Cancelled" &&
              item?.status !== "Completed" && (
                <SubmitButton
                  buttonType="button"
                  className={"green"}
                  btnText="Reassign Translator"
                  style={{ fontSize: "14px" }}
                  handleSubmit={handleAssignTranslator}
                />
              )}
            {/* {item.status == 'Under Review' &&
              <SubmitButton
                buttonType="button"
                className={"green"}
                btnText="Assign"
                handleSubmit={handleAssignTranslator}
              />
            )}
            {item.status !== "Completed" && (
              <SubmitButton
                buttonType="button"
                className={"tomatoRed"}
                btnText="Cancel"
                handleSubmit={handleCancelTranslator}
              />
            )}
            {item.status == "Assigned" && (
            } */}
            {/* {item.status !== "Completed" &&
              item.status !== "Cancelled" &&
              item.status !== "Client Cancelled" && (
                <SubmitButton
                  buttonType="button"
                  className={"tomatoRed"}
                  btnText="Cancel Translation"
                  style={{ fontSize: "14px" }}
                  handleSubmit={handleCancelTranslator}
                />
              )} */}
            {/* {(item.status == "Assigned" ||
              item.status == "Submission Rejected") && (
              <SubmitButton
                buttonType="button"
                className={"green"}
                btnText="Upload Translated Documents"
                style={{ fontSize: "14px" }}
                handleSubmit={handleUploadDocumentTranslator}
              />
            )} */}
          </div>
        </div>

        {mileageCheck("extra_mileage") &&
        mileageCheck("extra_mileage_request") == null ? (
          <div className="row_main_head align-items-center softAlert waiting">
            <h3>The vendor has requested extra mileage</h3>
            {checkPermission("Extra Mileage") && (
              <SubmitButton
                buttonType="button"
                className={"green"}
                btnText="View Request"
                style={{ fontSize: "14px" }}
              />
            )}
          </div>
        ) : mileageCheck("extra_mileage") &&
          mileageCheck("extra_mileage_request") == 1 ? (
          <div className="softAlert approved">
            <h3>
              The extra mileage request for this appointment have been approved.
            </h3>
          </div>
        ) : mileageCheck("extra_mileage") &&
          mileageCheck("extra_mileage_request") == 0 ? (
          <div className="softAlert rejected">
            <h3>
              The extra mileage request for this appointment have been rejected.
            </h3>
          </div>
        ) : (
          ""
        )}

        <TranslationViewTable item={item} />

        {item?.quotations && item?.quotations[0]?.approved == 1 && (
          <Link
            to={`/translation/invite-translators/${item?.id}`}
            type="button"
            className="main_button"
          >
            Invite Translators
          </Link>
        )}
      </div>

      {item && item?.translation_invoices && (
        <>
          <div className="card_table p-4">
            <div className="row_main_head mb-3">
              <h2 className={`main_heading`}>Invoice</h2>
            </div>
            <InvoiceTable
              item={item}
              onMarkInvoiceAsPaid={onMarkInvoiceAsPaid}
            />
          </div>
        </>
      )}

      {item && item?.translation_translated_files?.length > 0 && (
        <>
          <div className="card_table p-4">
            <div className="row_main_head mb-3">
              <h2 className={`main_heading`}>Translated Documents</h2>
            </div>
            <TranslatedDocumentsTable
              item={item}
              onApproveSubmmision={onApproveSubmmision}
              callViewApi={callViewApi}
            />
          </div>
        </>
      )}

      <div className="card_table p-4">
        <div className="row_main_head mb-3">
          <h2 className={`main_heading`}>Original Documents</h2>
        </div>
        <TransLogsTable item={item} />
      </div>

      <div className="card_table p-4">
        <div className="row_main_head mb-3">
          <h2 className={`main_heading`}>Translation Logs</h2>
        </div>
        <LogsTable logs={logs} />
      </div>
    </div>
  );
};

export default TranslationView;
